module.exports = function(TomSelect) {

	const keepNumberRadio = document.getElementById("keep-number");
	const numberInput = document.getElementById("keep-number-input");
	const numberDonorInput = document.getElementById("number-donor-input");
	const portabilityCnt = document.getElementById("portability-cnt");
	const portabilityDetailsCnt = document.getElementById("portability-details-cnt");

	const subscriptionTypeSelect = new TomSelect("#subscription-type", {
		valueField: "serviceType",
		labelField: "description",
		searchfield: "description",
		create: false,
		render: {
			no_results: function(data, escape) {
				return "<div class='no-results'>" + escape(this.input.dataset.noRecords) + "</div>";
			}
		},
		onChange: function(value) {

			const portabiltyInfoCnts = portabilityDetailsCnt.children;

			for (let i = 0; i < portabiltyInfoCnts.length; i++) {
				
				if (portabiltyInfoCnts[i].dataset.serviceType == value) {
					portabiltyInfoCnts[i].classList.remove("hidden");
				} else {
					portabiltyInfoCnts[i].classList.add("hidden");
				}
			}

			const height = (() => {
				const containerHeight = portabilityCnt.children[0].offsetHeight;
				const detailsHeight = portabilityDetailsCnt.offsetHeight;

				return containerHeight + detailsHeight + 25;
			})();

			if (numberDonorInput.value != 1 ) {

				portabilityCnt.style.maxHeight = `${height}px`;
			} else {
				
				portabilityCnt.removeAttribute("style")
			}
		}
	});

	function detailsBuilder(typeId, title, desc) {
	
		return `<div data-service-type="${typeId}">
					<p class="mb-2 text-xl font-semibold">${title}</p>
					<p>${desc}</p>
				</div>`;
	}

	function resetAll() {

		subscriptionTypeSelect.clear();
		subscriptionTypeSelect.clearOptions();
		subscriptionTypeSelect.disable();
		portabilityCnt.removeAttribute("style");
		portabilityDetailsCnt.innerHTML = "";

		document.getElementById("portability-collapse")
			.removeAttribute("style");
	}

	numberInput.addEventListener("input", function() {

		const spinner = document.getElementById("load-provider-spinner");
		const error = document.getElementById("keep-number-error");

		this.value = this.value.replace(/[^0-9]/g, "");

		resetAll();

		if ( this.value.length != 8 ) {
			
			return false;
		}
		
		error.classList.add("hidden");
		spinner.classList.remove("hidden");
		spinner.classList.add("inline-block");

		axios.post("/get-subscription-types", {
			mobileNumber: this.value
		})
		.then(res => {
			const {NumberDonor} = res.data;
			const {ReasonCode} = res.data;
			const {ClientMessage} = res.data;
			const {RecordSignature} = res.data;
			const subscriptionTypes = res.data.CurrentProviderServiceTypeDescriptions;
			const portabilityDesc = res.data.CurrentProviderServiceTypePortabilityDescriptions;

			if ( ReasonCode == 0 ) {
				
				for (let i = 0; i < subscriptionTypes.length; i++) {

					subscriptionTypeSelect.addOption({
						serviceType: subscriptionTypes[i].ServiceType,
						description: subscriptionTypes[i].Description
					});

					if ( portabilityDesc[i] === undefined ) continue;

					portabilityDetailsCnt.innerHTML += detailsBuilder(subscriptionTypes[i].ServiceType, subscriptionTypes[i].Description, portabilityDesc[i].Description);
				}

				document.getElementById("record-signature-input")
					.value = RecordSignature;

				numberDonorInput.value = NumberDonor;
				
				subscriptionTypeSelect.enable();
			} else {
				
				error.innerHTML = ClientMessage;
				error.classList.remove("hidden");
			}
		})
		.catch(err => {

			console.log(err);
		})
		.finally(() => {

			spinner.classList.add("hidden");
			spinner.classList.remove("inline-block");
		})
	});

	keepNumberRadio.addEventListener("change", function() {

		resetAll();
		numberInput.value = "";
		numberDonorInput.value = "";
	});
};